import React, { Fragment, useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPage, toggleSelect } from '../Actions/Library.action';
import Pagination from './Pagination';
import { calculatePager } from '../Services/Pagination.service';

const LibraryDocuments = () => {
  const dispatch = useDispatch();
  const [pager, setPager] = useState({});
  const { documents, selected, pageNumber } = useSelector(
    (state) => state.library
  );
  useEffect(() => {
    setPager(calculatePager(documents.total, pageNumber, { pageSize: 10 }));
  }, [documents]);
  const changePageIndex = (index) => {
    dispatch(setPage(index));
  };
  const countSize = (size) => {
    return (size / 1024).toFixed(1);
  };
  const handleCheckbox = (docId) => {
    const _selected = [...selected];
    const index = _selected.indexOf(docId);
    if (index !== -1) {
      _selected.splice(index, 1);
    } else {
      _selected.push(docId);
    }
    dispatch(toggleSelect(_selected));
  };
  const selectAll = () => {
    if (selected.length < documents.items?.value.length) {
      const allIds = [];
      documents.items?.value.forEach((item) => allIds.push(item.id));
      dispatch(toggleSelect(allIds));
    } else if (
      selected.length > 0 &&
      selected.length === documents.items?.value.length
    ) {
      dispatch(toggleSelect([]));
    }
  };
  return (
    <Fragment>
      <div className="row library__top">
        <div className="columns small-12 large-5">
          <input
            type="checkbox"
            checked={
              selected.length > 0 &&
              selected.length === documents.items?.value.length
            }
            onChange={selectAll}
          />
          File name
        </div>
        <div className="columns small-12 large-2">Type</div>
        <div className="columns small-12 large-2">Size</div>
      </div>
      <div>
      {documents.items?.value?.map((doc, index) => (
        <div
          key={doc.id}
          className="row library__doc"
        >
          <div className="columns small-12 large-5 library__doc--name">
            <input
              type="checkbox"
              checked={selected.includes(doc.id)}
              onChange={(e) => handleCheckbox(doc.id)}
              />
              <div>{doc.displayName ?? doc.name}</div>
          </div>
          <div className="columns small-12 large-2">{doc.documentType}</div>
          <div className="columns small-12 large-2">
            {countSize(doc.size)} (KB)
          </div>
          <div className="columns small-12 large-3 download__link">
            <a href={doc.url} download>
              download
            </a>
          </div>
        </div>
      ))}
      </div>
      <Pagination model={pager} onChange={changePageIndex} />
      {documents.items?.value.length === 0 ? (
        <div className="row library__notFoundBox">
          <div className="columns small-12 library__notFound">
            No documents found. Please try another search filter.
          </div>
        </div>
      ) : (
        ''
      )}
    </Fragment>
  );
};

export default LibraryDocuments;
